/* unplugin-vue-components disabled */import script from "./ManageLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageLayout.vue?vue&type=script&setup=true&lang=js"

import "./ManageLayout.vue?vue&type=style&index=0&id=d1d1a7ba&lang=less"

const __exports__ = script;

export default __exports__